"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _redux = require("redux");
var _reactI18next = require("react-i18next");
var _dompurify = _interopRequireDefault(require("dompurify"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _EmojiObjects = _interopRequireDefault(require("@material-ui/icons/EmojiObjects"));
var _MiradorMenuButton = require("mirador/dist/es/src/components/MiradorMenuButton");
var _WindowCanvasNavigationControls = _interopRequireDefault(require("mirador/dist/es/src/containers/WindowCanvasNavigationControls"));
var _htmlRules = _interopRequireDefault(require("mirador/dist/es/src/lib/htmlRules"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var OSDViewer = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('mirador/dist/es/src//containers/OpenSeadragonViewer'));
  });
});

// Styles
var styles = function styles(theme) {
  return {
    windowViewer: {},
    wrap: {
      display: 'flex',
      flex: 1
    },
    viewer: {
      position: 'relative',
      display: 'flex',
      flex: 1
    },
    container: {
      'font-family': '"Roboto", "Helvetica", "Arial", sans-serif',
      'z-index': 1,
      flex: '0 0 auto',
      'background-color': '#ffffff',
      padding: '0.75rem',
      'box-sizing': 'border-box',
      'max-width': '50%',
      height: '100%',
      'overflow-y': 'auto',
      'scroll-behavior': 'smooth',
      'border-left': "2px solid " + (0, _colorManipulator.alpha)('#000000', 0.15),
      display: function display(_ref) {
        var textsAvailable = _ref.textsAvailable,
          visible = _ref.visible;
        return textsAvailable && visible ? null : 'none';
      }
    },
    paragraph: {
      margin: '0.25em 0'
    },
    lineWrap: {
      position: 'relative',
      width: '100%',
      transition: 'background-color 0.3s ease',
      '&:hover': {
        'background-color': function backgroundColor(_ref2) {
          var color = _ref2.color,
            opacity = _ref2.opacity;
          return (0, _colorManipulator.alpha)(color, opacity - 0.15 > 0 ? opacity - 0.15 : 0);
        }
      }
    },
    button: {
      appearance: 'none',
      border: 0,
      display: 'block',
      cursor: 'pointer',
      fontSize: '15.4px',
      padding: '0.5em 2em 0.5em 0.5em',
      lineHeight: '1.2',
      'background-color': 'transparent'
    },
    line: {
      width: '100%',
      'text-align': 'left'
    },
    isHighlighted: {
      'background-color': function backgroundColor(_ref3) {
        var color = _ref3.color,
          opacity = _ref3.opacity;
        return (0, _colorManipulator.alpha)(color, opacity);
      },
      '&:hover': {
        'background-color': function backgroundColor(_ref4) {
          var color = _ref4.color,
            opacity = _ref4.opacity;
          return (0, _colorManipulator.alpha)(color, opacity);
        }
      }
    },
    correction: {
      position: 'absolute',
      top: 0,
      right: 0,
      fontSize: '24px',
      padding: '0.2em 0.25em',
      display: 'none',
      color: theme.palette.primary.main,
      transition: 'color 0.3s ease',
      '&, &:hover': {
        background: 'transparent'
      },
      '&:hover': {
        color: theme.palette.primary.dark
      }
    },
    correctionIcon: {
      fontSize: '1em',
      lineHeight: 0,
      padding: 0
    },
    showCorrection: {
      display: 'block'
    }
  };
};
var MAX_POLL_ITERATION_LIMIT = 200;

/**
 * Represents a WindowViewer in the mirador workspace. Responsible for mounting
 * OSD and Navigation
 */
var WindowViewer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(WindowViewer, _Component);
  /** */
  function WindowViewer(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {};
    _this.lineRefs = [];
    return _this;
  }
  var _proto = WindowViewer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.highlightLineByQueryParams();
  }

  /** Register OpenSeadragon callback when viewport changes */;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var highlightedLine = this.props.highlightedLine;
    if (highlightedLine && (highlightedLine === null || highlightedLine === void 0 ? void 0 : highlightedLine.initiator) !== 'text' && highlightedLine !== prevProps.highlightedLine) {
      this.scrollTo(highlightedLine);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.lineRefs = [];
  };
  _proto.highlightLineByQueryParams = function highlightLineByQueryParams() {
    var _this2 = this;
    var _this$props = this.props,
      doSetCanvas = _this$props.doSetCanvas,
      doHighlightLine = _this$props.doHighlightLine;
    var lineParam = this.getQuery('line');
    var fetchTextPollIterations = 0;
    if (lineParam) {
      var _lineParam$split = lineParam.split(','),
        newCanvasId = _lineParam$split[0],
        lineX = _lineParam$split[1],
        lineY = _lineParam$split[2];
      if (newCanvasId) {
        doSetCanvas(newCanvasId);
      }
      if (lineX && lineY) {
        // Unfortunately, the text is not available immediately after the canvas is set.
        // We need to poll for it...
        // At the moment, I can't figure out a better approach. :(
        var clearTextPollInterval = setInterval(function () {
          var textIsCompleted = !!_this2.props.pageTexts.find(function (text) {
            return (text === null || text === void 0 ? void 0 : text.canvasId) === newCanvasId;
          });
          if (textIsCompleted) {
            doHighlightLine(newCanvasId, {
              x: Number(lineX),
              y: Number(lineY)
            }, 'text');
          }
          if (textIsCompleted || fetchTextPollIterations > MAX_POLL_ITERATION_LIMIT) {
            clearInterval(clearTextPollInterval);
          }
          fetchTextPollIterations++;
        }, 300);
      }
    }
  };
  _proto.scrollTo = function scrollTo(_ref5) {
    var index = _ref5.index;
    if (Array.isArray(this.lineRefs)) {
      var element = this.lineRefs[index];
      if (element) {
        var method = null;
        if (typeof element.scrollIntoViewIfNeeded === 'function') {
          method = 'scrollIntoViewIfNeeded';
        } else if (typeof element.scrollIntoView === 'function') {
          method = 'scrollIntoView';
        }
        if (method !== null) {
          element[method]({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }
    }
  };
  _proto.getQuery = function getQuery(q, urlToParse) {
    if (urlToParse === void 0) {
      urlToParse = window.location.search;
    }
    return (urlToParse.match(new RegExp('[?&]' + q + '=([^&]+)')) || [null, null])[1];
  };
  _proto.getEmailLink = function getEmailLink(line) {
    var _this$props2 = this.props,
      correction = _this$props2.correction,
      t = _this$props2.t,
      manifestMetadata = _this$props2.manifestMetadata,
      manifestTitle = _this$props2.manifestTitle,
      canvasId = _this$props2.canvasId,
      canvasIndex = _this$props2.canvasIndex;

    // Get metadata and convert it to a proper structure
    var metadata = manifestMetadata === null || manifestMetadata === void 0 ? void 0 : manifestMetadata.reduce(function (acc, labelValuePair) {
      var _ref6;
      return acc.concat([(_ref6 = {}, _ref6[labelValuePair.label] = _dompurify["default"].sanitize(labelValuePair.values.join(', '), _htmlRules["default"]['iiif']), _ref6)]);
    }, []);
    var metadataString = metadata.reduce(function (acc, labelValuePair) {
      return acc.concat([Object.keys(labelValuePair)[0] + ": " + Object.values(labelValuePair)[0]]);
    }, []).join('\r\n');

    // Defining an url which allows the user to open the viewer with the current canvas and line highlighted
    // Current URL is taken as a base, all query parameter are omitted, except for those defined in 'emailUrlKeeyParams' and the line parameter is added.
    var currentUrl = new URL(window.location.href);
    var url = new URL(currentUrl.origin + currentUrl.pathname);
    var params = new URLSearchParams(currentUrl.search);
    for (var _iterator = _createForOfIteratorHelperLoose(params), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
        key = _step$value[0],
        value = _step$value[1];
      if (correction.emailUrlKeepParams.includes(key)) {
        url.searchParams.set(key, value);
      }
    }
    url.searchParams.set('line', canvasId + "," + line.x + "," + line.y);

    // add email recipient, if defined
    var to = correction.emailRecipient || '';
    // subject is defined in locales
    var subject = t('ocrCorrectionSubject') || '';
    // body is defined in locales, placeholders are replaced with passed values
    var body = t('ocrCorrectionBody', {
      metadata: metadataString,
      signature: manifestTitle,
      text: line.text,
      url: decodeURIComponent(url.href),
      // decodeURIComponent is needed to avoid encoding issues
      page: canvasIndex + 1
    }) || '';
    return "mailto:?to=" + encodeURIComponent(to) + "&subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
  }

  /** */;
  WindowViewer.getDerivedStateFromError = function getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }

  /**
   * Renders things
   */;
  _proto.render = function render() {
    var _this3 = this;
    var _this$props3 = this.props,
      windowId = _this$props3.windowId,
      canvasId = _this$props3.canvasId,
      classes = _this$props3.classes,
      correction = _this$props3.correction,
      skipEmptyLines = _this$props3.skipEmptyLines,
      pageTexts = _this$props3.pageTexts,
      textsAvailable = _this$props3.textsAvailable,
      textsFetching = _this$props3.textsFetching,
      doHighlightLine = _this$props3.doHighlightLine,
      t = _this$props3.t;
    var hasError = this.state.hasError;
    if (hasError) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    }
    return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react["default"].createElement("div", null)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.wrap
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.viewer
    }, /*#__PURE__*/_react["default"].createElement(OSDViewer, {
      windowId: windowId
    }, /*#__PURE__*/_react["default"].createElement(_WindowCanvasNavigationControls["default"], {
      windowId: windowId
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.container
    }, textsAvailable && !textsFetching && (pageTexts === null || pageTexts === void 0 ? void 0 : pageTexts.map(function (page) {
      var _page$lines;
      return page === null || page === void 0 ? void 0 : (_page$lines = page.lines) === null || _page$lines === void 0 ? void 0 : _page$lines.map(function (line, index) {
        var showLine = !skipEmptyLines || line.width > 0 && line.height > 0 && line.text.trim().length > 0;
        return showLine && /*#__PURE__*/_react["default"].createElement("p", {
          ref: function ref(_ref7) {
            _this3.lineRefs[index] = _ref7;
            return true;
          },
          className: classes.paragraph,
          key: "line_" + line.x + "_" + line.y
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.lineWrap + " " + (line.isHighlighted && classes.isHighlighted)
        }, /*#__PURE__*/_react["default"].createElement("button", {
          className: classes.line + " " + classes.button,
          type: "button",
          onClick: function onClick() {
            doHighlightLine(canvasId, line, 'text');
          }
        }, line.text), (correction === null || correction === void 0 ? void 0 : correction.enabled) && line.text && /*#__PURE__*/_react["default"].createElement(_MiradorMenuButton.MiradorMenuButton, {
          size: "small",
          className: classes.correction + " " + (line.isHighlighted && classes.showCorrection),
          "aria-label": t('ocrCorrectionTooltip'),
          onClick: function onClick(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            window.open(_this3.getEmailLink(line), '_blank');
          }
        }, /*#__PURE__*/_react["default"].createElement(_EmojiObjects["default"], {
          className: classes.correctionIcon
        }))));
      });
    })))));
  };
  return WindowViewer;
}(_react.Component);
WindowViewer.propTypes = process.env.NODE_ENV !== "production" ? {
  canvasId: _propTypes["default"].string,
  canvasIndex: _propTypes["default"].number,
  classes: _propTypes["default"].object,
  color: _propTypes["default"].string,
  correction: _propTypes["default"].object,
  skipEmptyLines: _propTypes["default"].bool,
  doHighlightLine: _propTypes["default"].func,
  doSetCanvas: _propTypes["default"].func,
  highlightedLine: _propTypes["default"].object,
  manifestTitle: _propTypes["default"].string,
  manifestMetadata: _propTypes["default"].array,
  opacity: _propTypes["default"].number,
  pageTexts: _propTypes["default"].array,
  t: _propTypes["default"].func.isRequired,
  textsAvailable: _propTypes["default"].bool,
  textsFetching: _propTypes["default"].bool,
  visible: _propTypes["default"].bool,
  windowId: _propTypes["default"].string.isRequired
} : {};
var enhance = (0, _redux.compose)((0, _reactI18next.withTranslation)(), (0, _withStyles["default"])(styles));
var _default = enhance(WindowViewer);
exports["default"] = _default;